const WORD_START = /(^|[\s-])(\p{L})/gu;

/**
 * Uppercases the first letter of every word, treating whitespace and hyphens as word
 * boundaries and leaving the rest of each word untouched.
 * Suggestions arrive from the Algolia query-suggestions index lower-cased; this is
 * display-only formatting — the value sent to search and tracking stays unchanged.
 */
export const capitalizeWords = (text) =>
    text.replace(WORD_START, (_match, boundary, letter) => boundary + letter.toUpperCase());
